
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h4>{`Szenario B: Mit Proximity Tracing App`}</h4>
    <p>{`Der Bund hat die Installation einer App, die von beiden ETH entwickelt wurde,
empfohlen. Dank Bluetooth-Technologie des Smartphones werden die `}<strong parentName="p">{`Begegnungen
von mehr als 15 Minuten Dauer und weniger als 1,5 Meter Entfernung anonym
registriert`}</strong>{`. So wird selbst ein Nebeneinandersitzen im ÖV festgestellt.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;